import * as React from 'react';
import { Link } from 'react-router';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { formatDateTimeDisplay } from 'js/utils/DateTimeUtils';

import { CMLText } from 'bundles/cml';

import 'css!./__styles__/ThreadPreviewItem';

class ThreadPreviewItem extends React.Component {
  static propTypes = {
    snippet: PropTypes.object.isRequired,
    createdAt: PropTypes.number.isRequired,
    link: PropTypes.string.isRequired,
    title: PropTypes.string,
    creator: PropTypes.shape({
      fullName: PropTypes.string.isRequired,
    }),
    openLinkInNewTab: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    openLinkInNewTab: false,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const { title, snippet, creator, createdAt, link, openLinkInNewTab } = this.props;

    const dateTimeDisplay = formatDateTimeDisplay(createdAt, 'MMM D, YYYY');
    const creatorName = creator?.fullName;

    return (
      <li className="rc-ThreadPreviewItem" tabIndex={0}>
        {/* @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call. */}
        <Link className="nostyle" to={link} target={openLinkInNewTab ? '_blank' : null}>
          <div className={classNames('body-2-text', 'result-title')}>{title}</div>
          <div className={classNames('body-1-text', 'entry-snippet')}>
            <CMLText cml={snippet} />
          </div>
          <div className="entry-metadata label-text">
            {creatorName && `${creatorName} · `}
            {dateTimeDisplay}
          </div>
        </Link>
      </li>
    );
  }
}

export default ThreadPreviewItem;
